import { type Extension, type Range, StateField } from "@codemirror/state";
import { Decoration, type DecorationSet, EditorView } from "@codemirror/view";

export type PinnedRange = { from: number; to: number };

const pinned = Decoration.mark({ class: "cm-pinned" });

export function pinnedExtension(ranges: readonly PinnedRange[]): Extension {
  if (ranges.length === 0) return [];
  return StateField.define<DecorationSet>({
    create(state) {
      const docLength = state.doc.length;
      const values: Range<Decoration>[] = [];
      for (const r of ranges) {
        const from = Math.max(0, Math.min(r.from, docLength));
        const to = Math.max(0, Math.min(r.to, docLength));
        if (from >= to) continue;
        values.push(pinned.range(from, to));
      }
      return Decoration.set(values, true);
    },
    update(value) {
      return value;
    },
    provide: (f) => EditorView.decorations.from(f),
  });
}
